import moment from "moment";
import React, { useEffect, useState } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router";
import { compose } from "underscore";
import { updateProfile } from "../../redux/action";
import { PROFILE } from "../../redux/constant";
import { resetTin, searchTin, searchTinSuccess } from "../redux/actions";

import {
  CustomButton,
  CustomInput,
  DefaultLoader,
  StepLabel,
} from "../../../components";

import { Typography } from "@mui/material";
import LoadingInput from "../../../components/LoadingInput";
import { allowedIdType } from "../../../utils/allowedIdType";
import { NO, NRIC, TIN_MS_ERROR_MESSAGE, YES } from "../../../utils/constants";
import styles from "../styles";
import { Tooltip } from "../../../components";
const UpdateTIN = props => {
  const {
    loading,
    profile,
    updateProfile,
    history,
    resetTin,
    searchTin,
    searchingTin,
    searchTinSuccess,
    searchTinError,
    validatingTIN,
    tin,
  } = props;

  console.log("profile: ", profile);

  const originalTIN =
    profile?.identities?.find(
      identity => identity.idTypeCd === "TAX" && identity.taxType === "EInvoice"
    )?.idNo || "";

  const userNric =
    profile?.identities?.find(identity => identity.idTypeCd === NRIC)?.idNo ||
    "";

  const [isOptInForNotification, setOptInForNotification] = useState(() =>
    profile?.optIn ? YES : NO
  );

  const [formStatus, setFormStatus] = React.useState("idle");
  const [isInitialized, setIsInitialized] = useState(false);

  const localIdentity = profile?.identities?.find(allowedIdType);

  // Initialize component state first
  useEffect(() => {
    const profileTin =
      profile?.identities?.find(
        identity =>
          identity.idTypeCd === "TAX" && identity.taxType === "EInvoice"
      )?.idNo || "";

    if (profileTin) {
      searchTinSuccess(profileTin);
    } else {
      resetTin();
    }

    setIsInitialized(true);
  }, [profile, resetTin, searchTinSuccess]);

  // Only trigger searchTin after initialization and when user opts in
  useEffect(() => {
    if (
      isInitialized &&
      isOptInForNotification === YES &&
      !searchingTin &&
      !tin &&
      !searchTinError &&
      userNric
    ) {
      searchTin({
        idType: NRIC,
        idNo: userNric,
      });
    }
  }, [
    isOptInForNotification,
    searchingTin,
    tin,
    userNric,
    isInitialized,
    searchTin,
    searchTinError,
  ]);

  const handleUpdate = () => {
    setFormStatus("submitting");

    const edited = JSON.stringify([tin, isOptInForNotification]);
    const initial = JSON.stringify([originalTIN, profile?.optIn ? YES : NO]);

    // untouched tin
    // untouched option

    if (searchTinError || edited === initial) return;

    const identities = [
      {
        idTypeCd: localIdentity?.idTypeCd, //R
        idNo: localIdentity?.idNo, //R
        citizenship: localIdentity?.citizenship, //R
      },
    ];

    const CRS = profile?.identities.find(
      identity => identity.idTypeCd === "TAX" && identity.taxType === "CRS"
    );

    if (isOptInForNotification === YES && tin) {
      identities.push({
        idTypeCd: "TAX",
        idNo: tin,
        citizenship: "MY",
        taxType: "EInvoice",
      });
    }

    if (CRS) {
      identities.push({
        idTypeCd: "TAX", //R
        idNo: CRS.idNo, //R
        citizenship: CRS.citizenship, //R
        taxType: "CRS",
      });
    }

    const payload = {
      masterId: profile?.masterId, //R
      email: profile?.email, //R
      mobileNo: profile?.mobileNo, //R
      fullName: profile?.fullName, //R
      townOfBirth: profile?.townOfBirth, //R
      dob: moment(profile?.dob).format("YYYY-MM-DD"), //R
      race: profile?.race, //R
      natureOfBusinessCd: profile?.natureOfBusinessCd, //R
      occupationTypeCd: profile?.occupationTypeCd, //R
      maritalStatusCd: profile?.maritalStatusCd, //R
      yearlyIncomeLevelCd: profile?.yearlyIncomeLevelCd, //R
      sourceOfFundCd: profile?.sourceOfFundCd,
      investmentObjCd: profile?.investmentObjCd,
      employerName: profile?.employerName,
      identities,
      isVc: Boolean(profile?.isVc),
      optIn: isOptInForNotification === YES && Boolean(tin),
      address: {
        line1: profile?.contacts.find(
          contact => contact.contactTypeCd === "PERMANENT"
        ).line1, //R
        line2: profile?.contacts.find(
          contact => contact.contactTypeCd === "PERMANENT"
        ).line2,
        line3: profile?.contacts.find(
          contact => contact.contactTypeCd === "PERMANENT"
        ).line3,
        postCode: profile?.contacts.find(contact => contact.postCode).postCode, //R
        city: profile?.contacts.find(
          contact => contact.contactTypeCd === "PERMANENT"
        ).city,
        state: profile?.contacts.find(contact => contact.state).state, //R,
        country: localIdentity?.citizenship,
      },
    };

    if (payload.isVc) {
      payload.vcDescription = profile?.vcDescription;
    }

    const reset = () => {
      setFormStatus("idle");
    };

    /* if (tin === originalTIN || isTINNumberExist === YES) {
      return updateProfile({ payloadData: payload, from: PROFILE }, reset);
    } */

    /* validateTin({
      payload: {
        idType: localIdentity?.idTypeCd,
        idValue: localIdentity?.idNo,
        tin: TIN,
      },
      callback: err => {
        if (err?.errorCode === "ETN-00002") {
          setTinErrorMessage(
            "Validation with LHDN failed, please enter a valid TIN"
          );
          return;
        }

        if (err) return;

        updateProfile({ payloadData: payload, from: PROFILE }, reset);
      },
    }); */
    updateProfile({ payloadData: payload, from: PROFILE }, reset);
  };

  return (
    <div style={{ backgroundColor: "#fff", ...styles.container }}>
      {(loading || validatingTIN) && <DefaultLoader />}
      <StepLabel
        title="E-invoice notification"
        onClick={() => history.back()}
        containerStyles={{ margin: "16px 16px 22px" }}
      />
      <form style={{ margin: "16px 16px 0 16px" }}>
        <CustomInput
          label="Opt in for e-invoice notification"
          name="isOptInForNotification"
          value={isOptInForNotification}
          onChange={e => {
            const value = e.target.value;
            setOptInForNotification(value);
            setFormStatus("idle");
          }}
          isEdit={true}
          isRadio={true}
        />
        {isOptInForNotification === YES && (
          <>
            <Typography
              color="textPrimary"
              sx={{
                fontWeight: "700",
                fontSize: "14px",
                lineHeight: 1.57,
                marginBottom: "8px",
              }}
            >
              Your Tax Identification Number (TIN) retrieved from the LHDN
              website
            </Typography>
            <LoadingInput
              placeholder={
                searchingTin
                  ? "Retrieving TIN"
                  : searchTinError
                  ? "TIN retrieval failed"
                  : ""
              }
              value={tin}
              disabled
              loading={searchingTin}
              helperText={searchTinError ? TIN_MS_ERROR_MESSAGE : ""}
              error={searchTinError}
            />
          </>
        )}
        <div style={styles.btnContainer}>
          <CustomButton
            text="Save"
            variant="contained"
            color="#fff"
            backgroundColor="#1278CC"
            onClick={handleUpdate}
            disabled={searchingTin}
          />
        </div>
      </form>
    </div>
  );
};

const withConnect = connect(
  state => ({
    loading: state.goal.loading,
    isModalOpen: state.goal.isModalOpen,
    errorMessage: state.goal.errorMessage,
    profile: state.goal.profile,
    validatingTIN: state.profileReducer.validatingTIN,
    tin: state.profileReducer.tin,
    searchingTin: state.profileReducer.searchingTin,
    searchTinError: state.profileReducer.searchTinError,
  }),
  {
    updateProfile,
    resetTin,
    searchTin,
    searchTinSuccess,
  }
);

export default compose(
  withRouter,
  withConnect
)(UpdateTIN);
